import LegalPage, { type LegalSection } from "./LegalPage";

const SECTIONS: LegalSection[] = [
  {
    id: "controller",
    heading: "Who is responsible",
    summary: "The data controller and how to reach us about your data.",
    points: [
      "Legal entity, registration number and address.",
      "Contact route for privacy questions and for exercising your rights.",
      "Supervisory authority you can complain to (IMY in Sweden).",
    ],
  },
  {
    id: "what-we-collect",
    heading: "What we collect",
    summary: "Every category of data linked to your account.",
    points: [
      "Account details: email, name, year of birth, bio and profile picture.",
      "Check-ins and On my way: which venue, when, and who you shared it with.",
      "Social graph: who you follow, who follows you, blocks and reports.",
      "Device data: push tokens, so notifications can reach your phone.",
      "Product events: that a check-in happened, used to measure the product.",
    ],
  },
  {
    id: "what-we-do-not",
    heading: "What we deliberately do not collect",
    summary: "The choices that shape the rest of this policy.",
    points: [
      "No background location tracking. Only explicit check-ins.",
      "No live routes or exact coordinates shared with other users.",
      "Sensors store no audio, no MAC addresses, no SSIDs and no packet contents.",
      "We store no location history beyond what a check-in needs.",
    ],
  },
  {
    id: "why",
    heading: "Why we use it, and on what legal basis",
    summary: "Each purpose mapped to its lawful basis under the GDPR.",
    points: [
      "Providing the service you asked for: performance of a contract.",
      "Notifications you have turned on: your consent, withdrawable in Settings.",
      "Safety, moderation and abuse prevention: legitimate interest.",
      "Measuring the product with anonymised events: legitimate interest.",
    ],
  },
  {
    id: "sharing",
    heading: "Who sees your data",
    summary: "Other users, venues and the processors we use.",
    points: [
      "Other users see only what you chose to share with them.",
      "Venues see aggregated numbers, never individual identifiable visitors.",
      "Processors: hosting, push delivery, music recognition and email delivery.",
      "Where the data is stored, and any transfers outside the EU/EEA.",
    ],
  },
  {
    id: "retention",
    heading: "How long we keep it",
    summary: "Retention per category, not one blanket period.",
    points: [
      "Check-ins and On my way: how long before they are deleted.",
      "Account data: kept until you delete your account.",
      "One-time email links: deleted shortly after they expire.",
      "Product events: kept anonymised after an account is deleted.",
    ],
  },
  {
    id: "your-rights",
    heading: "Your rights",
    summary: "What you can do, and where in the app you do it.",
    points: [
      "Access and portability: download everything from Settings as JSON.",
      "Correction: edit your profile in Settings.",
      "Erasure: delete your account in Settings, including dependent data.",
      "Objection and restriction: how to ask, and how fast we respond.",
      "Withdrawing notification consent at any time.",
    ],
  },
  {
    id: "security",
    heading: "How we protect it",
    summary: "The measures behind the promises above.",
    points: [
      "Passwords are stored hashed, never in plain text.",
      "Email links are stored as hashes, are single-use and expire.",
      "Access to production data is limited and logged.",
      "How we handle and communicate a data breach.",
    ],
  },
];

export default function Privacy() {
  return (
    <LegalPage
      title="Privacy Policy"
      intro="What Beatspot collects, why, and what you can do about it."
      sections={SECTIONS}
      versionKey="privacy"
    />
  );
}
